import React, {Component} from 'react';

class NoRowsOverlayComponent extends Component {
	render() {
		return <>No rows</>;
	}
}

export default NoRowsOverlayComponent;
